import React, { useEffect, useRef, useState } from "react";
import { ConfigProvider, Divider, Checkbox } from "antd";
import { message, Select } from "antd";
import CustomInput from "../../CustomInput";
import useUserStore from "../../../stores/store";
import ApiService from "../../../utils/ApiService";
import { constants } from "../../../constant/constants";
import {
  getIsRoundingApplicable,
  getPaymentMethods,
  getRoundValues,
  orderAcceptAndPaymentRequest,
  orderDiscountSubmit,
  processAndSendPrintCommand,
  showHidePaymentForm,
  validateLoyaltyDiscount,
  validateOrderAcceptPaymentForm,
} from "../../../services/order-processing-service";
import { getParsedNumber } from "../../../utils/Common";
import ConfirmModal from "../../modals/ConfirmModal";
import CustomLoader from "../../menu/CustomLoader";
import CustomInputNumber from "../../CustomInputNumber";
import OrderPaymentRefundModal from "../../modals/OrderPaymentRefundModal";
import LoyaltyMembership from "./LoyaltyMembership";
import {
  addMembership,
  defaultMembershipInfo,
  getDefaultDataForMembershipInfo,
  getPointBasedBoundaryValue,
} from "../../../services/loyalty-membership-service";
import OrderPaymentButtonsComponent from "./OrderPaymentButtonsComponent";
import {
  calculateReturnAmount,
  defaultRoundedValues,
  getDefaultDiscountInfo,
  getPriceSummary,
  shoudShowDiscountAmount,
  shouldDisplayDiscountableAmount,
} from "../../../services/order-payment-service";
import {
  getApplicableDiscountInfoAccordingToMaxAmount,
  getCouponInfo,
  getValidCoupons,
  isMinAmountSatisfiedCoupon,
} from "../../../services/coupon-service";

/**
 * This modal will appear for two actions one is accepting order and another is to receive payment.
 *
 * Accepting order has two main cases (order status in pending):
 * Case 1: The order is an online paid order. It will accept with cooking time.
 * Case 2: The order is unpaid means placed as counter payment or pay after eating. It will accept order as payment mode or pay later mode with cooking time
 *
 * Receive Payment
 * After accepting order with pay later mode, it will only appear to receive payment at any order status except pending
 *
 * There are some exceptional logic logics inside the modal
 * Logic 1: submitRef variable used only handle payment modal data resetting problem fixing. To ensure data loading everytime when modal open
 * an unique random UUID has been assigned to order on click payment icon so that order dependency injection happend but it causes a
 * peculiar problem while submitting any data that is immediate previous data is displaying temprarily
 *
 * @param {*} param0
 * @returns
 */
function OrderPaymentCommonComponent({
  order,
  onPaymentParentActionHandler,
  cookingTime = "30",
  shouldShowCookingTime = true,
  defaultDiscountTypes
}) {
  const [cashAmount, setCashAmount] = useState("");
  const [defaultRef, setDefaultRef] = useState("");
  const [cookingTimeRequired, setCookingTimeRequired] = useState(cookingTime);
  const [paymentMethod, setPaymentMethod] = useState("CASH");
  const [posBankId, setPosBankId] = useState("");
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [paymentMethodList, setPaymentMethodList] = useState([]);
  const [posBankList, setPostBankList] = useState([]);
  const [payLater, setPayLater] = useState(false);
  const [showPaymentFields, setShowPaymentFields] = useState(false);
  const [discount, setDisCount] = useState("");
  const [discountType, setDiscountType] = useState(defaultDiscountTypes[0].label);
  const [couponCode, setCouponCode] = useState("");
  const [isCouponEligible, setIsCouponEligible] = useState(false);
  const [isSplitted, setIsplitted] = useState(false);
  const [priceAfterDiscount, setPriceAfterDiscount] = useState(0);
  const [totalPayable, setTotalPayable] = useState(0);
  const [isFullDiscount, setIsFullDiscount] = useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [isConfirmModalForDeclineOpen, setIsConfirmModalForDeclineOpen] = useState(false);
  const [isOrderRefundModalOpen, setIsOrderRefundModalOpen] = useState(false);
  const [refundInfo, setRefundInfo] = useState(null);
  const [calcValues, setCalcValues] = useState({
    priceAfterDiscount: 0,
    serviceCharge: 0,
    sd: 0,
    vat: 0,
    grossTotal: 0,
  });

  const submitRef = useRef(false);
  const subtotal = order.isVatIncluded ? order.totalPriceBeforeDiscount : order.foodPriceBeforeDiscount;

  const [returnedAmount, setReturnedAmount] = useState(0);
  const [isRoundingApplicable, setIsRoundingApplicable] = useState(false);
  const [roundedValues, setRoundedValues] = useState({ ...defaultRoundedValues });

  const [loyaltyMembershipInfo, setLoyaltyMembershipInfo] = useState({ ...defaultMembershipInfo });
  const [couponInfo, setCouponInfo] = useState({});

  const [discountTypes, setDiscountTypes] = useState([...defaultDiscountTypes]);
  const [isLoading, setIsLoading] = useState(false);

  const { user, adminsPaymentOptions, posBanks, setNetworkCall, showNotification, restaurantId } = useUserStore();

  const activeCoupons = getValidCoupons();
  const couponDiscountTypeArr = activeCoupons.length > 0 ? [{ label: "Coupon", value: "Coupon" }] : [];

  const resetPaymentValues = () => {
    setPaymentMethod("CASH");
    setReturnedAmount(0);
    let updatedMethods = paymentMethods.map((item) => Object.assign(item, { amount: "", ref: "", posBankId: "" }));

    setCashAmount("");
    setPaymentMethods(updatedMethods);
    return updatedMethods;
  };

  const clearFields = (isOnSubmit = false) => {
    setCashAmount("");
    setDefaultRef("");
    setCookingTimeRequired(cookingTime);
    setPaymentMethod("CASH");
    setPaymentMethods((prevValues) =>
      prevValues.map((item) => Object.assign(item, { amount: "", ref: "", posBankId: "" })),
    );
    setPayLater(false);
    setDisCount("");
    setDiscountType(defaultDiscountTypes[0].label);
    setIsCouponEligible(false);
    setCouponCode('');
    setIsplitted(false);
    // setLoyaltyMembershipInfo({ ...defaultMembershipInfo });

    // it will cleared only if order submit otherwise it will not be restored original value when the modal simply closed and reopened.
    // It is initiated in order dependency as in same order, no param changed in order record dependency will not be executed while reopening modal
    if (isOnSubmit) {
      setTotalPayable(0);
    }

    setIsFullDiscount(false);
    setIsConfirmModalOpen(false);
    //reset the calculated values also
  };
  const handleCancel = () => {
    clearFields();
    onPaymentParentActionHandler("PAYMENT_CANCEL");
  };

  const onCancelRefundModal = () => {
    setIsOrderRefundModalOpen(false);
    setTimeout(() => {
      onPaymentParentActionHandler("PAYMENT_CANCEL");
    }, 100);
  };

  const onChangeCouponCode = (val) => {
    setIsCouponEligible(false);
    setCouponCode(val);
    
      const updatedMethods = resetPaymentValues();
      updateSummary(order, 0, defaultDiscountTypes[0].label, updatedMethods, roundedValues, isRoundingApplicable);
  };

  const applyCoupon = async () => {
    try {
      setIsLoading(true);
      const updatedMethods = resetPaymentValues();

      const result = await getCouponInfo(restaurantId, couponCode, user.token.token, showNotification);

      if (!result.success) {
        // result values
        return;
      }

      const couponData = result.data;
      setCouponInfo(couponData);      
      const errMsg = isMinAmountSatisfiedCoupon(order, couponData);
      
      if (errMsg) {
        showNotification(errMsg);
        return;
      }

      const convertedDisType = couponData.isDiscountInPercent
        ? constants.DISCOUNT_TYPE.PERCENTAGE
        : constants.DISCOUNT_TYPE.AMOUNT;

      const summary = getPriceSummary(
        order,
        couponData.discount,
        convertedDisType,
        updatedMethods,
        roundedValues,
        isRoundingApplicable,
      );

      const { acutalDiscount, actualDiscountType } = getApplicableDiscountInfoAccordingToMaxAmount(
        order.discountApplicablePrice,
        summary.calcValues.discountAmount,
        couponData,
      );

      updateSummary(order, acutalDiscount, actualDiscountType, updatedMethods, roundedValues, isRoundingApplicable);
      setIsCouponEligible(true);
    } catch (error) {
      showNotification("Failed to process coupon. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const updateDiscountTypes = (loyaltyDiscountTypes) => {
    if (loyaltyDiscountTypes.length > 0) {
      setDiscountTypes([...defaultDiscountTypes, ...loyaltyDiscountTypes, ...couponDiscountTypeArr]);
    }
  };
  const onChangeDiscountType = (value) => {
    setDisCount("");
    setIsCouponEligible(false);
    setCouponCode('');

    const findDiscountTypeById = discountTypes.find((it) => it.value === value);
    setDiscountType(findDiscountTypeById.label);
    onChangeDiscount("", findDiscountTypeById.label);

    if (findDiscountTypeById.label === "Spend Based") {
      const tmp = getParsedNumber(loyaltyMembershipInfo.loyaltyDiscountInfo.discountPercent);
      onChangeDiscount(tmp.toFixed(2), findDiscountTypeById.label);
    }
  };

  // Spend Based discount is percent and point based is amount (1 point = 1 tk)
  const onChangeDiscount = (value, discountTypeArg = "") => {
    const tmpVal = getParsedNumber(value);
    const distTypeArg = discountTypeArg || discountType;
    let disType = discountType;

    if (["Spend Based", "Percentage"].includes(distTypeArg)) {
      disType = constants.DISCOUNT_TYPE.PERCENTAGE;
    }

    if (["Point Based", "Amount"].includes(distTypeArg)) {
      disType = constants.DISCOUNT_TYPE.AMOUNT;
    }

    const boundaryAmount = getPointBasedBoundaryValue(distTypeArg, subtotal, loyaltyMembershipInfo.availablePoints);

    if (disType === constants.DISCOUNT_TYPE.PERCENTAGE && tmpVal <= 100) {
      setDisCount(value);
    } else if (disType === constants.DISCOUNT_TYPE.AMOUNT && tmpVal <= boundaryAmount) {
      setDisCount(value);
    } else {
      // as discount value is not set return from here so that summary not get updated
      return;
    }

    const updatedMethods = resetPaymentValues();
    updateSummary(order, value, distTypeArg, updatedMethods, roundedValues, isRoundingApplicable);
  };

  // Pass payment data to split bill page and handle everythin of it there
  const onSubmitSplitBill = () => {
    const codeCoupon = isCouponEligible ? couponCode : "";
    onPaymentParentActionHandler("SPLIT_BILL", {
      loyaltyMembershipInfo,
      roundedValues,
      isRoundingApplicable,
      paymentMethod,
      paymentMethods,
      discount,
      discountType,
      isSplitted,
      defaultRef,
      posBankId,
      totalPayable,
      couponCode: codeCoupon,
    });
  };
  /**
   * Hanlde discount. It is called guest discount
   */
  const onHandleDiscountSubmit = async () => {
    submitRef.current = true;
    const codeCoupon = isCouponEligible ? couponCode : "";
    setNetworkCall(true);

    const result = await orderDiscountSubmit(user.token.token, order._id, discount, discountType, codeCoupon);

    if (result.message) {
      showNotification(result.message, !result.success);
    }

    setNetworkCall(false);

    if (result.success) {
      onPaymentParentActionHandler("GUEST_BILL");
    }

    submitRef.current = false;
  };

  const handleOk = () => {
    if (isFullDiscount) {
      setIsConfirmModalOpen(true);
    } else {
      submitData();
    }
  };

  const submitData = async () => {
    const storeData = { ...roundedValues, isRoundingApplicable };

    localStorage.setItem("paymentReceiveRoundedValues", JSON.stringify(storeData));

    const error = validateLoyaltyDiscount(discountType, discount, loyaltyMembershipInfo);

    if (error) {
      message.warning(error);
      return;
    }

    const validationResult = validateOrderAcceptPaymentForm(
      order,
      payLater,
      cookingTimeRequired,
      totalPayable,
      paymentMethod,
      paymentMethods,
      discount,
      discountType,
      isSplitted,
      defaultRef,
      posBankId,
    );

    if (!validationResult.success) {
      message.warning(validationResult.message);
      return;
    }
    submitRef.current = true;
    setNetworkCall(true);
    const codeCoupon = isCouponEligible ? couponCode : "";

    const [loyaltyResult, result] = await Promise.all([
      addMembership(loyaltyMembershipInfo.shouldAddMembership, loyaltyMembershipInfo, user.token.token),
      orderAcceptAndPaymentRequest(
        user,
        order,
        payLater,
        cookingTimeRequired,
        totalPayable,
        paymentMethod,
        paymentMethods,
        discount,
        discountType,
        isSplitted,
        defaultRef,
        posBankId,
        codeCoupon,
      ),
    ]);

    submitRef.current = false;
    setNetworkCall(false);

    if (loyaltyResult.success) {
      setLoyaltyMembershipInfo((prev) => ({ ...prev, shouldAddMembership: false }));
    }

    if (!result.success) {
      message.warning(result.message);

      return;
    }

    if (!loyaltyResult.success) {
      showNotification(loyaltyResult.message);
    }

    // if order accepted as paylater socket event is not catched to update list
    // result.shouldReloadList = payLater && order.status.toLowerCase() === "pending" ? true : false;

    clearFields(true);

    if (order.status.toLowerCase() === "pending") {
      const printPurpose = order.payAfterEat ? 1 : 2;
      processAndSendPrintCommand(order, user.token.token, showNotification, printPurpose, false);
    }

    // When receive payment of an accepted order only invoice will be printed
    if (order.status.toLowerCase() !== "pending") {
      processAndSendPrintCommand(order, user.token.token, showNotification, 3, false);
    }

    onPaymentParentActionHandler("PAYMENT_DONE", result);
    return;
  };

  const handleOnConfirmFullDiscunt = () => {
    setIsConfirmModalOpen(false);
    submitData();
  };

  const handleDeclineConfirmation = () => {
    setIsConfirmModalForDeclineOpen(true);
  };

  const handleDecline = async () => {
    const payload = {
      orderId: order._id,
      selection: 0,
      payAfterEat: false,
    };

    setIsConfirmModalForDeclineOpen(false);
    setIsConfirmModalOpen(false);
    setNetworkCall(true);

    const res = await ApiService.ORDER_STATUS_CHANGE(payload, user.token.token);

    if (res.status === "ok" && res.payload.refundInfo) {
      setNetworkCall(false);
      setRefundInfo(res.payload.refundInfo);
      setIsOrderRefundModalOpen(true);
      return;
    }

    if (res.status === "ok") {
      showNotification("Order declined!", false);
      onPaymentParentActionHandler("PAYMENT_CANCEL");
      setNetworkCall(false);
    } else {
      showNotification(res.data.message);
      setNetworkCall(false);
    }
  };

  const updateCash = (val, onSelectPaymentMethod = "") => {
    setCashAmount(val);
    const selectedPaymentMethod = onSelectPaymentMethod || paymentMethod;
    const index = paymentMethodList.findIndex((it) => it.value === selectedPaymentMethod);

    handleChange(index, "amount", val);
  };

  const updateCookingTime = (val) => {
    if (/^\d*$/.test(val) && val.length < 3) {
      setCookingTimeRequired(val);
    }
  };

  const onSplitPaymentMethod = (val) => {
    resetPaymentValues();
    setIsplitted(val);
  };

  const onSelectPaymentMethod = (val) => {
    resetPaymentValues();
    const selectedItem = paymentMethodList.find((it) => it.value === val);
    setPaymentMethod(selectedItem.value);

    // when selecting payment method other than cash, set amount to total payable
    if (val !== "CASH") {
      updateCash(totalPayable.toFixed(2), selectedItem.value);
    } else {
      updateCash("", selectedItem.value);
    }
  };

  const handleChange = (index, field, value) => {
    const updatedMethods = [...paymentMethods];

    updatedMethods[index][field] = value;
    setPaymentMethods(updatedMethods);
  };

  const onChangeSplitAmount = (inputValueObj) => {
    handleChange(inputValueObj.name, "amount", inputValueObj.value);
  };

  /**
   * It will update the price summary information
   * @param {*} ord order
   * @param {*} dis discount
   * @param {*} disType discountType
   * @param {*} payMethods paymentMethods
   * @param {*} rValues roundedValues
   * @param {*} isRApplicable isRoundingApplicable
   */
  const updateSummary = (ord, dis, disType, payMethods, rValues, isRApplicable) => {
    const summary = getPriceSummary(ord, dis, disType, payMethods, rValues, isRApplicable);

    setCalcValues(summary.calcValues);
    setPriceAfterDiscount(summary.calcValues.priceAfterDiscount);
    setTotalPayable(summary.calcValues.grossTotal);
    setReturnedAmount(summary.returnedAmount);

    if (summary.calcValues.grossTotal === 0) {
      setIsFullDiscount(true);
    } else {
      setIsFullDiscount(false);
    }
  };

  useEffect(() => {
    if (submitRef.current) {
      return;
    }

    const disInfo = getDefaultDiscountInfo(order, defaultDiscountTypes);

    resetPaymentValues();
    setLoyaltyMembershipInfo(getDefaultDataForMembershipInfo(order));
    setPayLater(order.payAfterEat);
    setDisCount(disInfo.discount);
    setDiscountTypes([...defaultDiscountTypes, ...couponDiscountTypeArr]);
    setDiscountType(disInfo.discountType);
    setIsCouponEligible(disInfo.isCouponEligible);
    setCouponCode(order?.couponDiscount?.couponCode || "");
    setCouponInfo(order?.couponDiscount || {});
    updateSummary(
      order,
      disInfo.discount,
      disInfo.calculativeDisType,
      paymentMethods,
      roundedValues,
      isRoundingApplicable,
    );
  }, [order, defaultDiscountTypes]);

  useEffect(() => {
    setShowPaymentFields(showHidePaymentForm(order, payLater));
  }, [order, payLater]);

  // Fetch payment methods list
  useEffect(() => {
    const options = getPaymentMethods(adminsPaymentOptions);

    setPaymentMethods(options);
    setPaymentMethodList(JSON.parse(JSON.stringify(options)));
    setPaymentMethod(options[0]?.value);
  }, [adminsPaymentOptions]);

  useEffect(() => {
    const tmpList = [{ displayName: "Select Bank", posBankId: "" }, ...posBanks];
    setPostBankList(tmpList.map((item) => ({ label: item.displayName, value: item.posBankId })));
  }, [posBanks]);

  useEffect(() => {
    const rValues = getRoundValues(totalPayable);
    setRoundedValues(rValues);
    const isApplicableRound = getIsRoundingApplicable(paymentMethods, rValues);
    setIsRoundingApplicable(isApplicableRound);
    const retAmount = calculateReturnAmount(paymentMethods, totalPayable, rValues, isApplicableRound);
    setReturnedAmount(retAmount);
  }, [paymentMethods, totalPayable]);

  useEffect(() => {
    setCookingTimeRequired(cookingTime);
  }, [cookingTime]);

  return (
    <div className="flex flex-col font-uregular">
      <CustomLoader customLoaderFlag={isLoading}/>
      <Divider style={{ margin: "5px 0" }} />

      <div className="flex flex-col">
        {order.paymentType === "SSLC" && (
          <div className="ml-[4px] text-md font-uregular text-green-600 mb-10">
            Payment of total <b>{order.total}</b> taka was cleared by <b>Online</b>.
          </div>
        )}

        {/* Pay Later Checkbox */}
        {order.status === "pending" && order.paid === 0 && (
          <ConfigProvider
            theme={{
              token: {
                colorPrimary: "#572D86",
                colorPrimaryBorder: "#572D86",
                colorPrimaryHover: "#572D86",
                controlOutline: "#572D86",
                colorBorder: "#572D86",
              },
            }}
          >
            {" "}
            <div className="flex items-center mb-[16px] ml-[4px]">
              <Checkbox disabled={!user.isPayLater} checked={payLater} onChange={(e) => setPayLater(e.target.checked)}>
                Pay later
              </Checkbox>
            </div>
          </ConfigProvider>
        )}

        {order.status === "pending" && shouldShowCookingTime && (
          <CustomInput
            placeholder={`30`}
            value={cookingTimeRequired}
            setValue={updateCookingTime}
            showPadding={false}
            label={`Food Preparing time in minute`}
            highlight={false}
            required={true}
            isLableVertical={false}
            labelClass="py-[4px] pr-5 w-full"
            rightLabelText="Min"
          />
        )}

        {showPaymentFields && (
          <>
            {order.number && (
              <LoyaltyMembership
                order={order}
                loyaltyMembershipInfo={loyaltyMembershipInfo}
                setLoyaltyMembershipInfo={setLoyaltyMembershipInfo}
                updateDiscountTypes={updateDiscountTypes}
              />
            )}

            <Divider style={{ margin: "5px 0", borderColor: "#D3D3D3" }} />
            <div className="flex justify-between font-bold">
              <div>Subtotal</div>
              <div className="mb-3 text-red-600">
                {" "}
                {order.isVatIncluded
                  ? order.totalPriceBeforeDiscount.toFixed(2)
                  : order.foodPriceBeforeDiscount.toFixed(2)}{" "}
                TK
              </div>
            </div>
            {shouldDisplayDiscountableAmount(order, discountType, activeCoupons, couponCode) && (
              <div className="flex justify-between ">
                <div>Discountable Amount</div>
                <div className="mb-3 text-red-600"> {order.discountApplicablePrice.toFixed(2)} TK</div>
              </div>
            )}

            <div className="flex  w-full">
              <div className="w-full">Discount Type</div>
              <div className="mb-3 text-red-600 w-full">
                <Select
                  value={discountType}
                  className="w-full"
                  onChange={onChangeDiscountType}
                  options={discountTypes}
                />
              </div>
              <div className="pl-6"></div>
            </div>

            {discountType !== "Coupon" && (
              <div className="flex  w-full">
                <div className="w-full">
                  {discountType === "Point Based"
                    ? `Redeem Points (Min. ${loyaltyMembershipInfo.loyaltyDiscountInfo.minRedeemPoint})`
                    : "Discount"}
                </div>
                <div className="mb-3 w-full">
                  <CustomInputNumber
                    name="discount"
                    disabled={discountType === "Spend Based"}
                    placeholder={``}
                    value={discount}
                    setValue={onChangeDiscount}
                    isDecimalAllowed={true}
                    onPressEnter={() => {}}
                  />
                </div>
                {discountType === "Spend Based" ? <div className="pl-2">%</div> : <div className="pl-6"></div>}
              </div>
            )}

            {discountType === "Coupon" && (
              <div className="flex w-full mb-2">
                <div className="w-full">Coupon</div>
                <div className="w-full flex gap-4">
                  <div className="flex-grow">
                    <Select
                      value={couponCode}
                      className="w-full"
                      onChange={onChangeCouponCode}
                      options={activeCoupons}
                      allowClear
                    />
                  </div>
                  <div className="bg-blue-100 ">
                    <button
                      type="button"
                      onClick={applyCoupon}
                      style={{
                        backgroundColor: "#2EC114",
                        color: "#FFFFFF",
                        fontFamily: "ubold",
                        border: "none",
                        padding: "4px",
                        borderRadius: "4px",
                        cursor: "pointer",
                      }}
                    >
                      Apply
                    </button>
                  </div>
                </div>
                <div className="pl-6"></div>
              </div>
            )}

            {shoudShowDiscountAmount(discountType, discount, isCouponEligible) && (
              <div className="flex justify-between ">
                <div>Total Discount {" "}
                  {isCouponEligible && <>({couponInfo.discount.toFixed(2)}{couponInfo.isDiscountInPercent ? '%' : 'TK'})</>}
                </div>
                <div className="mb-3 text-red-600"> {(subtotal - calcValues.priceAfterDiscount).toFixed(2)} TK</div>
              </div>
            )}

            <Divider style={{ margin: "2px 0", borderColor: "#D3D3D3" }} />
            {!order.isVatIncluded && (order.serviceChargePercent > 0 || order.vatPercent > 0 || order.sd > 0) && (
              <>
                <div className="flex justify-between font-bold">
                  <div>Net Total</div>
                  <div className="mb-0 text-red-600">{priceAfterDiscount.toFixed(2)} TK</div>
                </div>
                <Divider style={{ margin: "2px 0", borderColor: "#D3D3D3" }} />
                {!order.isSupplementaryDutyIncluded && (
                  <div className="flex justify-between">
                    <div>Supplementary Duty</div>
                    <div className="mb-0">{calcValues.sd.toFixed(2)} TK</div>
                  </div>
                )}
                {!order.isServiceChargeIncluded && (
                  <div className="flex justify-between">
                    <div>Service Charge ({order.serviceChargePercent}%)</div>
                    <div className="mb-0">{calcValues.serviceCharge.toFixed(2)} TK</div>
                  </div>
                )}
                <div className="flex justify-between">
                  <div>Vat ({order.vatPercent}%)</div>
                  <div className="mb-0 ">{calcValues.vat.toFixed(2)} TK</div>
                </div>
                {/* {order.vatPercent > 0 && (
                )} */}
                <Divider style={{ margin: "2px 0", borderColor: "#D3D3D3" }} />
              </>
            )}

            <div className="flex justify-between font-bold">
              <div>Gross Total</div>
              <div className="mb-0 text-red-600">{calcValues.grossTotal.toFixed(2)} TK</div>
            </div>
            <Divider style={{ margin: "2px 0 20px 0", borderColor: "#D3D3D3" }} />

            <div className="flex justify-between">
              <div>Payment Method</div>
              <div>
                <ConfigProvider
                  theme={{
                    token: {
                      colorPrimary: "#572D86",
                      colorPrimaryBorder: "#572D86",
                      colorPrimaryHover: "#572D86",
                      controlOutline: "#572D86",
                      colorBorder: "#572D86",
                    },
                  }}
                >
                  {" "}
                  <div className="flex items-center mb-[2px] ml-[4px]">
                    <Checkbox
                      disabled={isFullDiscount}
                      checked={isSplitted}
                      onChange={(e) => onSplitPaymentMethod(e.target.checked)}
                    >
                      Split Bill
                    </Checkbox>
                  </div>
                </ConfigProvider>
              </div>
            </div>
            <Divider style={{ margin: "5px 0", borderColor: "#D3D3D3" }} />
            {!isSplitted && (
              <div className="flex justify-between items-center">
                <div className=" text-red-600 w-1/3 mr-10">
                  <Select
                    value={paymentMethod}
                    className="w-[100%]"
                    onChange={onSelectPaymentMethod}
                    options={paymentMethods}
                  />
                </div>

                <div className={`mr-4 ${paymentMethod === "CASH" ? "invisible" : "visible"} flex gap-2 items-center`}>
                  <div>
                    <input
                      value={defaultRef}
                      className={`w-full rounded-[5px] border-[1px] border-grey font-uregular px-[8px] py-[4px]`}
                      placeholder={"Ref"}
                      onChange={(e) => {
                        const value = e.target.value;
                        // Allow only alphanumeric, dash, dot — up to 20 characters
                        if (/^[a-zA-Z0-9.-]{0,20}$/.test(value)) {
                          setDefaultRef(value);
                        }
                      }}
                    />
                  </div>
                  {paymentMethod === "POS" && (
                    <div className="w-[200px]">
                      <Select value={posBankId} className="w-[100%]" onChange={setPosBankId} options={posBankList} />
                    </div>
                  )}
                </div>

                <div className="flex">
                  <div>
                    <CustomInputNumber
                      placeholder={"Amount"}
                      value={cashAmount}
                      setValue={updateCash}
                      isDecimalAllowed={paymentMethod !== "CASH"}
                      disabled={paymentMethod !== "CASH"}
                    />
                  </div>
                  <div className="pl-2">TK</div>
                </div>
              </div>
            )}
            {isSplitted && (
              <div className="flex flex-col my-4 space-y-4">
                {paymentMethods.map((item, index) => (
                  <div className="flex items-center space-x-2" key={item.value}>
                    <div className="w-[100px]">{item.label}</div>
                    <div
                      className={`${item.value === "CASH" ? "invisible" : "visible"} flex flex-1 gap-2 items-center`}
                    >
                      <div>
                        <input
                          value={item.ref}
                          className={`w-full rounded-[5px] border-[1px] border-grey font-uregular px-[8px] py-[4px]`}
                          placeholder={"Ref"}
                          onChange={(e) => {
                            const value = e.target.value;
                            // Allow only alphanumeric, dash, dot — up to 20 characters
                            if (/^[a-zA-Z0-9.-]{0,20}$/.test(value)) {
                              handleChange(index, "ref", value);
                            }
                          }}
                        />
                      </div>
                      {item.value === "POS" && (
                        <div className="w-[200px]">
                          <Select
                            value={item.posBankId}
                            className="w-[100%]"
                            onChange={(val) => handleChange(index, "posBankId", val)}
                            options={posBankList}
                          />
                        </div>
                      )}
                    </div>
                    <div className="w-[200px]">
                      <CustomInputNumber
                        name={index}
                        placeholder={"Amount"}
                        isDecimalAllowed={item.value !== "CASH"}
                        value={item.amount}
                        setValue={onChangeSplitAmount}
                        shouldSetValueSetObj={true}
                      />
                    </div>
                    <div>TK</div>
                  </div>
                ))}
              </div>
            )}

            <Divider style={{ margin: "2px 0 10px 0", borderColor: "#D3D3D3" }} />
            <div className="">
              {paymentMethods
                .filter((item) => item.amount > 0)
                .map((item) => (
                  <div className="flex justify-between" key={`${item.label}`}>
                    <div>{item.label}</div>
                    <div className="mb-0 ">
                      {Number(item.amount).toFixed(2)}
                      TK
                    </div>
                  </div>
                ))}
              <div className="flex justify-between">
                <div>{returnedAmount > 0 ? "Remaining Amount" : "Returned Amount"}</div>
                <div className="mb-0 ">{returnedAmount.toFixed(2)} TK</div>
              </div>

              {isRoundingApplicable && (
                <div className="flex justify-between">
                  <div>(+/-) Rounding</div>
                  <div className="mb-0 ">{roundedValues.decimalValue.toFixed(2)} TK</div>
                </div>
              )}
            </div>
            <Divider style={{ margin: "2px 0 5px 0", borderColor: "#D3D3D3" }} />
            <div className="flex justify-between font-bold">
              <div>Total Paid</div>
              <div className="mb-0 text-red-600">
                {isRoundingApplicable ? roundedValues.roundedPayable.toFixed(2) : totalPayable.toFixed(2)} TK
              </div>
            </div>
          </>
        )}
      </div>
      <Divider />
      <div>
        <OrderPaymentButtonsComponent
          context={""}
          orderStatus={order.status}
          paymentStatus={order.paid}
          handleDeclineConfirmation={handleDeclineConfirmation}
          handleCancel={handleCancel}
          onSubmitPayment={handleOk}
          onSubmitGuestBill={onHandleDiscountSubmit}
          onSubmitSplitBill={onSubmitSplitBill}
        />
      </div>
      <ConfirmModal
        isModalOpen={isConfirmModalOpen}
        centered
        records={{
          title: "Are you sure you want to offer the full discount amount?",
          handleOk: handleOnConfirmFullDiscunt,
          handleCancel: () => setIsConfirmModalOpen(false),
          confirmText: "Yes",
          cancelconfirmText: "No",
          customStyle: {
            top: 250,
          },
        }}
      ></ConfirmModal>
      <ConfirmModal
        isModalOpen={isConfirmModalForDeclineOpen}
        centered
        records={{
          title: "Are you sure to decline the order?",
          handleOk: handleDecline,
          handleCancel: () => setIsConfirmModalForDeclineOpen(false),
          confirmText: "Yes",
          cancelconfirmText: "No",
          customStyle: {
            top: 250,
          },
        }}
      />
      <OrderPaymentRefundModal
        openModal={isOrderRefundModalOpen}
        centered
        params={{
          onCancel: onCancelRefundModal,
          onHandleOk: onCancelRefundModal,
          order: { ...order, refundInfo },
        }}
      />
    </div>
  );
}

export default OrderPaymentCommonComponent;
